// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const StackedAreaChartIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="StackedAreaChartIcon" ref={forwardedRef} {...props}>
      <path d="M4.5 3H3v13a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-.5l-.002-.002V7.291H13.36l-3.347-4.233L5.88 8.021 4.5 6.974zm0 5.857 1.615 1.226 3.868-4.645 2.651 3.353h2.864v5.438l-5-4.23-3.5 3.983-2.498-1.99z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const StackedAreaChartIcon = /* @__PURE__ */ Object.assign(
  StackedAreaChartIconComponent,
  { displayName: 'StackedAreaChartIcon' },
);
